import * as React from 'react';

export interface NotFoundProps {}

export function NotFound(props: NotFoundProps) {
  return <div>NotFound</div>;
}
